// Ses paketlerinin plan listesi — VoiceDetail ve HerculesPage ortak kullanır.
//
// Plan satırı <button>'dır: /v2/bundles ayrı bir plan detay ucu sunmadığı için
// satın alma doğrudan checkout'a gider (bkz. UnlimitedDetail).

import React from 'react';
import { useTranslation } from 'react-i18next';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faDatabase,
  faClock,
  faArrowRight,
  faPhone,
  faCommentSms,
} from '@fortawesome/free-solid-svg-icons';
import { useCurrency } from '../../context/CurrencyContext';
import { formatPrice, pickPlanPrice } from '../../utils/currency';
import { formatDataOrUnlimited, formatValidity } from '../../utils/formatters';
import { isSellable } from './bundleCatalog';
import { formatAllowance } from './voicePlans';

const VoicePlanList = ({ plans, onBuy }) => {
  const { t } = useTranslation();
  const { currency } = useCurrency();

  return (
    <ul className="plan-list">
      {plans.map((plan) => {
        const price = formatPrice(pickPlanPrice(plan, currency), currency);
        const sellable = isSellable(plan);
        const voice = formatAllowance(t, plan.voiceMinutes, 'voice');
        const sms = formatAllowance(t, plan.smsCount, 'sms');
        return (
          <li key={plan.id}>
            <button
              type="button"
              className={`plan plan--button ${sellable ? '' : 'plan--disabled'}`}
              disabled={!sellable}
              onClick={() => onBuy(plan)}
            >
              <span className="plan-data">
                <FontAwesomeIcon icon={faDatabase} />
                {/* isUnlimited yalnızca VERİ için geçerlidir; konuşma/SMS ayrı. */}
                {formatDataOrUnlimited(t, plan.isUnlimited, plan.dataMb, { empty: '' })}
              </span>
              <span className="plan-validity">
                <FontAwesomeIcon icon={faClock} />
                {formatValidity(t, plan.validityDays)}
              </span>
              {(voice || sms) && (
                <span className="plan-badges">
                  {voice && (
                    <span className="plan-badge">
                      <FontAwesomeIcon icon={faPhone} />
                      {voice}
                    </span>
                  )}
                  {sms && (
                    <span className="plan-badge">
                      <FontAwesomeIcon icon={faCommentSms} />
                      {sms}
                    </span>
                  )}
                </span>
              )}
              {price && <span className="plan-price">{price}</span>}
              {sellable ? (
                <span className="plan-buy">
                  {t('detail.buy')}
                  <FontAwesomeIcon icon={faArrowRight} />
                </span>
              ) : (
                // priceId yoksa plan fiyatlanmamıştır; web'den satılamaz.
                <span className="plan-unavailable">{t('detail.notPriced')}</span>
              )}
            </button>
          </li>
        );
      })}
    </ul>
  );
};

export default VoicePlanList;
